import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import useFeatureDiscoveryFeatureDiscoveryQuery, {
	type useFeatureDiscoveryFeatureDiscoveryQuery$data,
	type useFeatureDiscoveryFeatureDiscoveryQuery$variables,
} from './__generated__/useFeatureDiscoveryFeatureDiscoveryQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadFeatureDiscovery = (): Promise<{
	data: useFeatureDiscoveryFeatureDiscoveryQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return query<
		useFeatureDiscoveryFeatureDiscoveryQuery$data,
		useFeatureDiscoveryFeatureDiscoveryQuery$variables
	>({
		query: useFeatureDiscoveryFeatureDiscoveryQuery,
	});
};
